import { Controller } from "stimulus"

export default class extends Controller {
  update() {
    let form = this.element
    form.requestSubmit();
  }
}